import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const Partnerships = () => {
  return (
    <>
      <SEO 
        title="Partnerships - Strategic Technology Partners | Abacies Logiciels"
        description="Explore Abacies Logiciels' strategic partnerships with leading technology providers, platforms, and industry leaders to deliver comprehensive solutions to our clients."
        keywords="partnerships, strategic partners, technology partnerships, business partnerships, Abacies partners"
      />

      <section className="hero-section">
        <div className="page-container">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-charcoal animate-fade-in">
              Partnerships
            </h1>
            <p className="text-xl text-titanium leading-relaxed animate-slide-up">
              This is the Partnerships page with sample content.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white">
        <div className="page-container">
          <div className="max-w-4xl mx-auto">
            <p className="text-titanium mb-6">
              Sample content for Partnerships. This page contains placeholder text and will be updated with actual content.
            </p>
            <Link to="/" className="btn-primary">Return Home</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Partnerships;
